import React, { Component } from 'react'
import './RoundCard.scss'

export default class RoundCard extends Component {
    render() {
        const { removePadding, children, scaleOnHover, className } = this.props

        return (
            <div
                className={`
                    roundcard 
                    ${removePadding ? 'nopadding' : ''}
                    ${scaleOnHover ? 'scaleonhover' : ''}
                    ${className ? className : ''}
                `}>
                {children || ''}
            </div>
        )
    }
}

RoundCard.defaultProps = {
    removePadding: true,
    scaleOnHover: true
}